import { turnSelectors } from '../selectors';
// ---- local imports ----

function _isLeased(car, currentTurn) {
	const carHasStarted = car.startTurn <= currentTurn;
	const carHasNotEnded = car.endTurn === null || car.endTurn === currentTurn;
	return carHasStarted && carHasNotEnded;
}

export function getAllCars(state) {
	return state.cars.allCars;
}

export function getLeasedCars(state) {
	return state.cars.leasedCars;
}

export function getLeasedCarsSinceTurnNumberInclusive(state, turn) {
	const allLeasedCars = getLeasedCars(state);

	return allLeasedCars.filter((car) => car.startTurn >= turn);
};

export function getCar(state, carId) {
	return getAllCars(state)[carId];
}

export function hasLeasedCar(state) {
	return getLeasedCar(state) !== undefined;
}

export function getLeasedCar(state) {
	const currentTurn = turnSelectors.getTurnNum(state);
	
	const allCarsEverLeased = getLeasedCars(state);
	const currentlyLeasedCar =
		allCarsEverLeased.find((car) => _isLeased(car, currentTurn));

	return currentlyLeasedCar;
}

export function getCarRent(state) {
	const car = getLeasedCar(state);
	
	if (!car) {
		return 0;
	}
	else {
		return car.price;
	}
}

export function getNextMonthCarRent(state) {
	const allCarsEverLeased = getLeasedCars(state);
	const nextMonthLeasedCars = 
		allCarsEverLeased.filter((car) => car.endTurn === null );

	const totalRent = nextMonthLeasedCars.reduce((total, car) => {
		return total + car.price;
	}, 0);

	return totalRent;
}

export function canLease(state) {
	const currentTurn = turnSelectors.getTurnNum(state);

	const activeCars = getLeasedCars(state)
		.find((entry) => entry.startTurn > currentTurn || entry.endTurn === null);
	
	const noActiveCars = activeCars === undefined;

	return noActiveCars;
}

export function hasCarUnleasedThisTurn(state) {
	const currentTurn = turnSelectors.getTurnNum(state);
	const car = getLeasedCars(state)
		.find((entry) => entry.endTurn === currentTurn);
	return car !== undefined;
}

export function getCarsAvailableForRent(state) {
	const all = Object.values(getAllCars(state));
	const allCarsEverLeased = getLeasedCars(state);
	
	return all.filter((car) => {
		const isNotCurrentlyLeased = allCarsEverLeased.find(
			(leasedCar) => (
				leasedCar.carId === car.id
				&& leasedCar.endTurn === null
			)
		) === undefined;

		return isNotCurrentlyLeased;
	});
}

export function getQuarterOfFirstLeasedCar(state) {
	const allCarsEverLeased = getLeasedCars(state);

	if (!allCarsEverLeased.length) {
		return -1;
	}

	let firstLeasedCarTurn = Number.POSITIVE_INFINITY;
	for (let car of allCarsEverLeased) {
		if (car.startTurn < firstLeasedCarTurn) {
			firstLeasedCarTurn = car.startTurn;
		}
	}

	return Math.ceil(firstLeasedCarTurn / 3);;
}

export function getNumberOfMonthsWithLeasedCarsDuringMission(state, mission) {
	if (!mission?.startedInTurn || !mission?.checkAtStartOfTurn) {
		return 0;
	}

	const missionStartTurn = mission.startedInTurn;
	const missionEndTurn = mission.checkAtStartOfTurn - 1;

	const leasedCars = getLeasedCars(state);

	let numberOfMonthsWithLeasedCars = 0;
	leasedCars.forEach((leasedCar) => {
		const carStartTurn = leasedCar.startTurn;
		const carEndTurn = leasedCar.endTurn ?? missionEndTurn;

		const overlapStart = Math.max(carStartTurn, missionStartTurn);
		const overlapEnd = Math.min(carEndTurn, missionEndTurn);

		if (overlapStart <= overlapEnd) {
			const monthWithThisCar = (overlapEnd - overlapStart) + 1;
			numberOfMonthsWithLeasedCars += monthWithThisCar;
		}
	})

	return numberOfMonthsWithLeasedCars;
}
